module.exports = __webpack_public_path__ + "img/HC1021-112.6140ba1a.jpg";